import { __awaiter } from "tslib";
import { RestService } from '../rest';
import { Auth } from "../session/types";
import { BankAccountType, bankAccountTypeLabel, BankAccountProduct } from "./types/BankAccountType";
const rest = new RestService();
export const getAccountsList = () => __awaiter(void 0, void 0, void 0, function* () {
    const { data: { data: accounts, error, }, } = yield rest.get('/api/v1/loan-list');
    return { accounts, error };
});
export const consumerVerifyPhone = (code) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        yield rest.post(`/api/kloans-authentication/consumer-verify-phone`, {
            access_token: localStorage.getItem(Auth.AUTH_ACCESS_TOKEN),
            confirmation_code: code,
        });
        return true;
    }
    catch (error) {
        return false;
    }
});
export const getFiDetailsByRoutingNumber = (routingNumber) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const { data: { data: FiData, error, }, } = yield rest.get(`/api/core-fedfi/ach/${routingNumber}`);
        return FiData;
    }
    catch (error) {
        throw error;
    }
});
export const validateRoutingNumber = (routingNumber) => __awaiter(void 0, void 0, void 0, function* () {
    if (!routingNumber || routingNumber.length !== 9) {
        return true;
    }
    try {
        yield getFiDetailsByRoutingNumber(routingNumber);
        return true;
    }
    catch (error) {
        return false;
    }
});
export const addBankAccount = (payload) => __awaiter(void 0, void 0, void 0, function* () {
    const createdAccount = yield rest.post(`/api/v1/bank-account`, payload);
    return createdAccount.data.data;
});
export { BankAccountType, bankAccountTypeLabel, BankAccountProduct, };
